module.exports = __webpack_public_path__ + "img/whatsapp 3.3484c961.svg";